import { SearchHighlighting, SearchSort } from '@aipb/gulliver/castor/model';
import { HeaderComponent } from '@aipb/gulliver/catalog/feature-header';
import { CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { HoverHighlightDirective } from '@aipb/shared/ui/directives';
import { InsideLoadingComponent } from '@aipb/shared/ui/loading';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ResultListItemBase } from '../result-list-item.base';

@Component({
  selector: 'cat-result-list-basic-item',
  templateUrl: './result-list-basic-item.component.html',
  styleUrls: ['./result-list-basic-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, HoverHighlightDirective, HeaderComponent, InsideLoadingComponent]
})
export class ResultListBasicItemComponent extends ResultListItemBase {
  @Input() sort: SearchSort[] = [];
  @Input() loading: boolean;

  @Input() highlighting: SearchHighlighting = {};

  @Output() detail: EventEmitter<CustomRecordItem> = new EventEmitter<CustomRecordItem>();
}
